import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { getPlanningTask } from '../../utils/planningTasks';
import {
  isPendingEngineerLane,
  isPendingManagerLane,
  isPendingQmLane,
  matchesSearch
} from './mroLabLanes';

export function useMroLabQueues(search = '') {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pipeline, setPipeline] = useState([]);
  const [pendingPlanning, setPendingPlanning] = useState([]);

  const fetchQueues = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      let hangar = { enableMroFacade: true, productMode: 'HANGAR' };
      try {
        const settingsRes = await axios.get('/api/mro/hangar-settings');
        hangar = settingsRes.data || hangar;
      } catch (_) {
        /* settings optional */
      }

      const [queueRes, planningRes] = await Promise.all([
        axios.get('/api/mro/queue'),
        hangar.productMode === 'HANGAR'
          ? axios.get('/api/mro/planning-queue').catch(() => ({ data: [] }))
          : Promise.resolve({ data: [] })
      ]);

      setPipeline(Array.isArray(queueRes.data) ? queueRes.data : []);
      const planningRows = Array.isArray(planningRes?.data) ? planningRes.data : [];
      setPendingPlanning(planningRows.map((wo) => ({ ...wo, planningTask: getPlanningTask(wo) })));
    } catch (err) {
      console.error('MRO Lab load failed', err);
      setPipeline([]);
      setPendingPlanning([]);
      setError(err.response?.data?.message || 'Failed to load MRO queues');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQueues();
  }, [fetchQueues]);

  const counts = useMemo(() => ({
    planning: pendingPlanning.length,
    manager: pipeline.filter(isPendingManagerLane).length,
    engineer: pipeline.filter(isPendingEngineerLane).length,
    qm: pipeline.filter(isPendingQmLane).length
  }), [pipeline, pendingPlanning]);

  const rowsByLane = useMemo(() => ({
    planning: pendingPlanning.filter((wo) => matchesSearch(wo, search)),
    manager: pipeline.filter(isPendingManagerLane).filter((wo) => matchesSearch(wo, search)),
    engineer: pipeline.filter(isPendingEngineerLane).filter((wo) => matchesSearch(wo, search)),
    qm: pipeline.filter(isPendingQmLane).filter((wo) => matchesSearch(wo, search))
  }), [pipeline, pendingPlanning, search]);

  return {
    loading,
    error,
    counts,
    rowsByLane,
    refresh: fetchQueues
  };
}
